import Applications from "../pages/Applications";

/** ATS includes Offer as a pipeline stage (no separate Offers nav item). */
export default function PortalAtsPanel() {
  return (
    <div className="min-h-0 flex-1 text-[hsl(var(--ds-fg))]">
      <Applications />
    </div>
  );
}
